import './api/navigation';

import angular from 'angular';

angular.module('folkeuni').factory('Navigation', function (NavigationApi, $q) {
  var navigation = null,
      navigationLoading = false,
      navigationPromise = null;

  return {
    getNavigation: function(rootId) {
      var deferred = $q.defer(),
          promise = navigationPromise ? navigationPromise : deferred.promise;

      if(!navigationLoading && navigation) {
        deferred.resolve(navigation);
      } else if(!navigationLoading) {
        navigationLoading = true;
        navigationPromise = promise;

        NavigationApi.getNavigation(rootId).then(function (res) {
          navigation = res.data;
          deferred.resolve(navigation);
          navigationLoading = false;
        }, function(res) {
          deferred.reject(res);
          navigationLoading = false;
        });
      }

      return promise;
    }
  };
});
